import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "survey-iii_gradient pe-10" }
const _hoisted_2 = { class: "z-index-1 d-flex justify-content-between align-items-center position-relative" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/logos/logo_background.png",
  alt: "Logo background",
  class: "logo_background h-100"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/logos/logo_background_2.png",
  alt: "Logo background",
  class: "logo_background_1 h-100"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center z-index-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/logos/iii-logo.png",
    alt: "",
    class: "h-100"
  }),
  /*#__PURE__*/_createElementVNode("h1", null, "INCLUSION IMPACT INDEX")
], -1)
const _hoisted_6 = { class: "d-flex z-index-1" }
const _hoisted_7 = { class: "d-md-inline" }
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}
const _hoisted_9 = {
  key: 1,
  class: "fas fa-download fs-5 ms-5"
}
const _hoisted_10 = { class: "d-md-inline" }
const _hoisted_11 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}
const _hoisted_12 = {
  key: 1,
  class: "fas fa-download fs-5 ms-5"
}
const _hoisted_13 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid",
  id: "kt_create_account_stepper",
  ref: "verticalWizardRef"
}
const _hoisted_14 = { class: "d-flex flex-row-fluid flex-center bg-white rounded me-9" }
const _hoisted_15 = { class: "py-20 w-100 px-9" }
const _hoisted_16 = { class: "pt-3" }
const _hoisted_17 = { class: "text-danger" }
const _hoisted_18 = { class: "d-flex justify-content-center bg-white rounded justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-450px" }
const _hoisted_19 = { class: "px-6 px-lg-10 px-xxl-15 py-20" }
const _hoisted_20 = { class: "stepper-nav" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-line w-40px" }, null, -1)
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "stepper-check fas fa-check"
}
const _hoisted_24 = {
  key: 1,
  class: "stepper-number"
}
const _hoisted_25 = { class: "stepper-label" }
const _hoisted_26 = { class: "stepper-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SurveyStep = _resolveComponent("SurveyStep")!
  const _component_survery_structure = _resolveComponent("survery-structure")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!
  const _component_survery_summary = _resolveComponent("survery-summary")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            "active-class": "active",
            class: "btn btn-dark-blue me-5",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.printResult && _ctx.printResult(...args)))
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.translate("SURVEY_BUTTON_DOWNLOAD_EMPTY_SURVEY")) + " ", 1),
              (_ctx.surveyStructurDownloadLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                : (_openBlock(), _createElementBlock("i", _hoisted_9))
            ])
          ]),
          _createElementVNode("button", {
            "active-class": "active",
            class: "btn btn-dark-blue",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.printReport && _ctx.printReport(...args)))
          }, [
            _createElementVNode("span", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.translate("SURVEY_BUTTON_DOWNLOAD_SURVEY_WITH_DATA")) + " ", 1),
              (_ctx.surveySummaryDownloadLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                : (_openBlock(), _createElementBlock("i", _hoisted_12))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surveyStepList, (step, index) => {
            return (_openBlock(), _createElementBlock("div", {
              "data-kt-stepper-element": "content",
              class: _normalizeClass(step.id == _ctx.$route.params.step ? 'current' : ''),
              key: 'step' + step.id
            }, [
              _withDirectives(_createVNode(_component_SurveyStep, {
                input_values_in_step: _ctx.surveyObj.getInputByStep(index + 1),
                input_values_reduce: _ctx.surveyObj.getInputReducedByStep(index + 1),
                survey_obj: _ctx.surveyObj,
                step: step,
                errors: _ctx.errors,
                totalSteps: _ctx.totalSteps,
                isActiveStep: step.id <= _ctx.activeStepId,
                activeStepId: _ctx.activeStepId
              }, null, 8, ["input_values_in_step", "input_values_reduce", "survey_obj", "step", "errors", "totalSteps", "isActiveStep", "activeStepId"]), [
                [_vShow, step.id == _ctx.$route.params.step]
              ])
            ], 2))
          }), 128)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("small", _hoisted_17, _toDisplayString(_ctx.backendErrorMessage[_ctx.translateKey("error")]), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surveyStepList, (step) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["stepper-item", _ctx.getStepClass(_ctx.bullets, step.id)]),
                "data-kt-stepper-element": "nav",
                key: step.id
              }, [
                _hoisted_21,
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  class: "p-5 stepper-icon w-40px h-40px",
                  onClick: ($event: any) => (_ctx.navigateStep(step.id))
                }, [
                  (step.id !== parseInt(_ctx.$route.params.step) && _ctx.bullets[step.id - 1])
                    ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                    : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(step.id), 1))
                ], 8, _hoisted_22),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(step[_ctx.translateKey("descrizione")]), 1)
                ])
              ], 2))
            }), 128))
          ])
        ])
      ]),
      _createVNode(_component_vue3_html2pdf, {
        "show-layout": false,
        "float-layout": true,
        "enable-download": true,
        "preview-modal": false,
        filename: "survey structure",
        "pdf-quality": 2,
        "manual-pagination": true,
        "pdf-format": "a4",
        "pdf-orientation": "portrait",
        "pdf-content-width": "100%",
        onProgress: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onProgress($event))),
        "html-to-pdf-options": _ctx.pdfOptionsForSurveyStructure,
        ref: "html2Pdf"
      }, {
        "pdf-content": _withCtx(() => [
          _createVNode(_component_survery_structure)
        ]),
        _: 1
      }, 8, ["html-to-pdf-options"]),
      _createVNode(_component_vue3_html2pdf, {
        "show-layout": false,
        "float-layout": true,
        "enable-download": true,
        "preview-modal": false,
        filename: "survey summary",
        "pdf-quality": 2,
        "manual-pagination": true,
        "pdf-format": "a4",
        "pdf-orientation": "portrait",
        "pdf-content-width": "100%",
        onProgress: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPrintSummaryProgress($event))),
        "html-to-pdf-options": _ctx.pdfOptionsForSurveyStructure,
        ref: "html2PdfSummary"
      }, {
        "pdf-content": _withCtx(() => [
          _createVNode(_component_survery_summary)
        ]),
        _: 1
      }, 8, ["html-to-pdf-options"])
    ], 512)
  ], 64))
}